/**
 * The seven attributes of Bible 4.1 (ADR-138 decision 1), in the order the stored columns, the wire and the dialogue
 * checks all follow. A leaf: it imports nothing, so the rules' types and the dialogue marks may both read it.
 */
export const ATTRIBUTES = ["might", "agility", "vitality", "intellect", "willpower", "perception", "presence"] as const;

/**
 * One of the seven attributes.
 */
export type Attribute = (typeof ATTRIBUTES)[number];

/**
 * Whether a value names an attribute.
 *
 * @param value Anything.
 * @returns True for one of the seven names.
 */
export function isAttribute(value: unknown): value is Attribute {
  return typeof value === "string" && (ATTRIBUTES as readonly string[]).includes(value);
}
